'use client'
import { Prisma } from '@prisma/client'
import { usePathname, useRouter } from 'next/navigation'
import React, { useEffect, useMemo, useState } from 'react'
import Select from 'react-select'

type Props = {
    typesBiens: Prisma.VentesTypeGetPayload<{}>[]
    searchParams: URLSearchParams
}

const FilterVentesTypeBien = ({ typesBiens, searchParams }: Props) => {
    
    const pathName = usePathname()
    const params = useMemo(() => new URLSearchParams(searchParams), [searchParams])
    const router = useRouter()

    const [typeBienSelected, setTypeBienSelected] = useState<Prisma.VentesTypeGetPayload<{}>>()

    const handleChange = async (typeBien: Prisma.VentesTypeGetPayload<{}>) => {

        params.delete('typesBiens')
        params.set('page', '1')

        params.append('typesBiens', typeBien.id!.toString())

        setTypeBienSelected(typeBien)
        router.push(pathName + '?' + params.toString())
    };

    useEffect(() => {
        if (params.has('typesBiens')) {
            setTypeBienSelected(typesBiens.find((typeBiens) => typeBiens.id === parseInt(params.get('typesBiens')!)))
        } else {
            setTypeBienSelected(undefined)
        }
    }, [params, typesBiens])

    
    return (
        <div className="w-full lg:w-1/3">
            <Select
                id='select-type-bien'
                placeholder="Type de bien"
                styles={{
                    control: (provided: any) => ({
                        ...provided,
                        width: '100%',
                    }),
                    container: (provided: any) => ({
                        ...provided,
                        width: '100%',
                    }),
                    menu: (provided: any) => ({
                        ...provided,
                        width: '100%',
                        zIndex: 600
                    }),
                }}
                options={typesBiens}
                getOptionLabel={(option: any) => `${option.label}`}
                getOptionValue={(option: any) => option.id!.toString()}
                noOptionsMessage={() => "Aucun type correspondant"}
                isClearable={true}
                isSearchable={true}
                isMulti={false}
                onChange={(selectedOptions: any) => {
                    handleChange(selectedOptions)
                }}
                value={typeBienSelected}
                aria-label='Filtre type de biens'
            />
        </div>
    )
}

export default FilterVentesTypeBien